// Premium model constants
export const FREE_FOOD_CARDS_LIMIT = 20;
export const FREE_FAVORITES_LIMIT = 5;

export const PREMIUM_PRICE_ID = "price_1S6F6G3vNin52rXpX88hobXS";
export const PREMIUM_PRODUCT_ID = "prod_T2JjOKNWynqlp7";
export const PREMIUM_PRICE_NOK = 99;

export const PREMIUM_FEATURES = [
  "Alle matkort",
  "Ubegrensede favoritter",
  "Matlogg og kalender",
  "Avansert sporing (streaks, achievements)",
  "Månedlig oppsummering",
  "Artikler og veiledning",
  "Matdagbok per barn",
] as const;

export const FREE_FEATURES = [
  "20 gratis matkort",
  "Opptil 5 favoritter",
  "Grunnleggende søk og filter",
  "Baby-profil",
  "Artikler og guide",
] as const;
